<script lang="ts">
  export interface VErrorLayoutProps {
    status: number;
  }
</script>

<script lang="ts" setup>
  defineProps<VErrorLayoutProps>();
  const statusUrl = window.__VITE_ENVS.SERVICE_STATUS_URL as string;

  const { t } = useI18n({
    messages: {
      ru: {
        title: 'Ошибка сервера',
        description: 'Вы можете проверить статус',
        link: 'здесь',
      },
      en: {
        title: 'Server Error',
        description: 'You can check service status',
        link: 'here',
      },
    },
  });
</script>

<template>
  <VBaseLayout :title="t('title')">
    <div class="min-h-320 h-full flex justify-center items-center">
      <div class="flex">
        <span
          class="flex items-center font-bold text-xl border-r-2 pr-24 border-gray">
          {{ status || 500 }}
        </span>
        <div class="pl-24">
          <h1 class="font-bold">{{ t('title') }}</h1>
          <div>
            {{ t('description') }}
            <a class="link" target="_blank" :href="statusUrl">{{
              t('link')
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </VBaseLayout>
</template>
